<template>
    <div class="bbp-timer-modal-body-company">
      <BBPCheckbox
        title="Add to History Tab of Company"
        :defaultValue="companyIsTab"
        @change="onChangeCompanyTab"
      />
      <div
        v-for="(item, index) in companies"
        class="bbp-timer-modal-body-company-item"
        :key="item._id"
      >
        <span
          v-if="item.name"
          class="bbp-timer-modal-body-company-item__title"
          @click="onDelete(item, index)"
        >
          {{ item.name }}
        </span>
        <div
          v-if="index === companies.length - 1 && options.length"
          class="bbp-timer-modal-body-company__wrap"
        >
          <div
            class="bbp-timer-modal-body-company__add"
            v-html="plusIcon()"
          />
          <BBPSelectImage
            :options="options"
            label="name"
            :hideImage="true"
            :scrollTop="scrollTop"
            @change="setSelect"
          />
        </div>
        <transition name="fade">
          <div
            v-if="isError"
            class="bbp-timer-modal-body-company-error"
          >
            <div
              class="bbp-timer-modal-body-company-error__icon"
              v-html="errorIcon()"
            />
           {{!options.length ? 'No companies available' : 'Company not selected'}}
          </div>
        </transition>
      </div>
    </div>
</template>

<script>
import BBPCheckbox from '@/components/Main/InputFields/BBPCheckbox/BBPCheckbox'
import BBPSelectImage from '@/components/Main/InputFields/BBPSelectImage/BBPSelectImage'
import {PLUS_ICON, ERROR_ICON} from '@/constants/icons'
import CompanyApi from '@/api/Company/api'
import {TIMER_STATUS} from '@/constants/timerStatus'

export default {
  name: 'BBPTimerModalSelectCompany',
  components: {
    BBPSelectImage,
    BBPCheckbox
  },
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    defaultModel: {
      type: Object,
      default: () => ({})
    },
    companies: {
      type: Array,
      default: () => ([])
    },
    companyIsTab: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    scrollTop: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    options: [],
    plusIcon: PLUS_ICON,
    errorIcon: ERROR_ICON
  }),
  computed: {
    isError: {
      get () {
        return this.error
      },
      set (data) {
        this.$emit('update:error', data)
      }
    },
    clientCompanies: {
      get () {
        return this.$store.getters.clientCompanies
      },
      set (data) {
        this.$store.dispatch('setClientCompanies', data)
      }
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    activeTimerStatus () {
      const { subTimers = {} } = this.activeTimer
      const { status = 4 } = subTimers
      return status
    }
  },
  methods: {
    onDelete (item, index) {
      this.$emit('onDelete', index)
      this.options.unshift(item)
    },
    setSelect (value) {
      this.isError = false
      this.$emit('setSelect', value)
      const currentIndex = this.options.findIndex(({_id}) => _id === value._id)
      this.options.splice(currentIndex, 1)
    },
    onChangeCompanyTab ({value}) {
      this.isError = false
      this.$emit('onChangeCompanyTab', value)
    },
    async getCompanies () {
      const { client = {} } = this.row
      const { _id, id } = client
      const body = {
        limit: 9999,
        page: 1,
        client: _id || id
      }
      try {
        const { data } = await CompanyApi.getContactCompanies(body)
        const { clientcompanies = [] } = data
        this.options = JSON.parse(JSON.stringify(clientcompanies))
        this.clientCompanies = clientcompanies
        this.setDefaultCompany()
      } catch (err) {
        console.error(err)
      }
    },
    setDefaultCompany () {
      const { commentText = '' } = this.defaultModel
      if (this.activeTimerStatus === TIMER_STATUS.SAVED && !commentText) return
      this.companies.forEach((el) => {
        const currentIndex = this.options.findIndex(({_id}) => _id === el._id)
        if (currentIndex === -1) return
        this.options.splice(currentIndex, 1)
      })
    }
  },
  beforeMount () {
    const [firstItem = {}] = this.clientCompanies
    const { client: firstItemClient = {} } = firstItem
    const { id } = firstItemClient
    const { client = {} } = this.row
    if (this.clientCompanies.length && id === client._id) {
      this.options = [...this.clientCompanies]
      this.setDefaultCompany()
    } else {
      this.getCompanies()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

.bbp-timer-modal-body-company {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  grid-gap: 10px 0;

  &__wrap {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    position: relative;

    &_disabled {
      pointer-events: none;
    }
  }

  &__add {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: $color-wild-sand;

    &:hover {
      opacity: 0.8;
      transition: 0.2s;
      cursor: pointer;
    }
  }
}

.bbp-timer-modal-body-company-item {
  display: flex;
  align-items: center;

  &__title {
    font-weight: 400;
    line-height: 17px;
    font-size: 14px;
    color: $color-denim;
    margin: 0 6px 0 0;
    transition: 0.2s;

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
}

.bbp-timer-modal-body-company-error {
  display: flex;
  align-items: center;
  grid-gap: 0 4px;
  margin: 0 0 0 10px;
  color: $color-pomegranate;
  font-size: 13px;

  &__icon {
    display: flex;
  }
}
</style>

<style lang="scss">

.bbp-timer-modal-body-company {

  .bb-loader-select-header {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
  }

  .bb-loader-select-dropdown-menu {
    max-width: 281px;
    max-height: 264px !important;
  }

  .bbp-checkbox__title {
    margin-right: 6px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalSelectCompany.vue